var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{class:_vm.estilo,style:(_vm.preenchimento),attrs:{"role":"progressbar","aria-valuenow":_vm.valorAtual,"aria-valuemin":_vm.valorMinimo,"aria-valuemax":_vm.valorMaximo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }